export default __webpack_public_path__ + "static/media/REFIN_PRESTIGIO_CALACATTA_ORO_MESH.ed1f7922.jpg";